module.exports = __webpack_public_path__ + "static/media/stackoverflow.acb71e0f.png";